<template>
  <div class="review-text">
    <div class="content">
      <a>
        <p v-html="$t(`review_text_${index}`)" />

        <strong v-html="$t(`review_author_${index}`)" />
      </a>
    </div>
  </div>
</template>
<script>
import { language } from '../../../helpers'

export default {
  props: {
    index: {
      type: Number,
    },
  },
  setup() {
    const lang = language()

    const allReviewLink = 'https://www.google.com/search?q=glassery&sxsrf=ALiCzsa3Yr_m64I9iwxzsmdgZp-3fCR7xw%3A1664871321061&ei=mes7Y5ymA_T_7_UPsY2rwAg&ved=0ahUKEwjc1sD9kMb6AhX0_7sIHbHGCogQ4dUDCA4&uact=5&oq=glassery&gs_lcp=Cgdnd3Mtd2l6EAMyBAgjECcyBQgAEIAEMgoIABCABBAKEMsBMggIABCABBDLATIKCAAQgAQQChDLATIKCAAQgAQQChDLATIECAAQHjIJCAAQHhDJAxAKMgYIABAeEAoyBggAEB4QCjoKCAAQRxDWBBCwAzoGCCMQJxATOgQIABBDOhAILhCxAxCDARDHARDRAxBDOgsIABCABBCxAxCDAToKCAAQsQMQgwEQQzoLCC4QgAQQsQMQ1AI6BQguEIAEOggILhCABBCxAzoOCC4QgAQQsQMQgwEQ1AI6CwguEIAEEMcBEK8BOgcILhDUAhBDOggILhCABBDLAToOCC4QgAQQxwEQrwEQywFKBAhBGABKBAhGGABQowlYtxZg2RpoA3ABeACAAaUDiAGiD5IBCTAuMy40LjAuMZgBAKABAcgBCMABAQ&sclient=gws-wiz#lrd=0x4db3a08673641941:0xc5b4f7f13cddf415,1,,,'

    return { lang, allReviewLink }
  },
  data() {
    return {}
  },
}
</script>
